<mat-dialog-content>
    <!-- Backdrop clicks and ESC are disabled application-wide, so this is the way out. -->
    <button type="button" class="close" (click)="close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>

    <h4 mat-dialog-title>
        {{data.registrationNumber}}
        <span class="ml-2" *ngIf="details?.inspectionCompletedAt">
            <small class="text-muted" translate>icashComparison.completedAt</small>
            <small class="text-muted"> {{details.inspectionCompletedAt}}</small>
        </span>
    </h4>

    <div [hidden]="!dataLoaded">
        <!-- ******************************************************
        ************** Header summary *************
        ****************************************************** -->
        <dl class="row mb-3">
            <dt class="col-5" translate>icashComparison.statusLabel</dt>
            <dd class="col-7">
                <span [ngClass]="matchStatusClass(details?.matchStatus)" translate>{{matchStatusKey(details?.matchStatus)}}</span>
            </dd>

            <dt class="col-5" translate>icashComparison.inspectionTotal</dt>
            <dd class="col-7">{{details?.inspectionTotal | number:'1.2-2'}} {{details?.currencyCode}}</dd>

            <dt class="col-5" translate>icashComparison.receiptTotal</dt>
            <dd class="col-7">
                {{details?.receiptTotal | number:'1.2-2'}} {{details?.currencyCode}}
                <span class="text-muted" *ngIf="details?.fiscalNumber">
                    (<span translate>icashComparison.receiptNumber</span> {{details.fiscalNumber}}<span *ngIf="details?.receiptCompletedAt">, {{details.receiptCompletedAt}}</span>)
                </span>
            </dd>

            <!-- Shown whenever a number was typed at the point: where it differs from the number
                 printed on the receipt, someone mistyped it and this is where that becomes visible. -->
            <ng-container *ngIf="details?.inspectionFiscalNumber">
                <dt class="col-5" translate>icashComparison.inspectionFiscalNumber</dt>
                <dd class="col-7">
                    {{details.inspectionFiscalNumber}}
                    <i class="fa fa-exclamation-triangle text-warning ml-1"
                       *ngIf="details?.fiscalNumber && !fiscalNumbersAgree()"
                       title="{{'icashComparison.pairing.fiscalNumberUnmatched' | translate}}"></i>
                </dd>
            </ng-container>

            <ng-container *ngIf="details?.paymentTypeName">
                <dt class="col-5" translate>icashComparison.paymentType</dt>
                <dd class="col-7">{{details.paymentTypeName}}</dd>
            </ng-container>

            <ng-container *ngIf="details?.difference">
                <dt class="col-5" translate>icashComparison.difference</dt>
                <dd class="col-7 font-weight-bold">{{details.difference | number:'1.2-2'}} {{details?.currencyCode}}</dd>
            </ng-container>

            <ng-container *ngIf="details?.suggestion">
                <dt class="col-5" translate>icashComparison.suggestion</dt>
                <dd class="col-7">
                    <span translate>icashComparison.suggestion.missingService</span> {{details.suggestion}}
                </dd>
            </ng-container>
        </dl>

        <!-- ******************************************************
        ************** Line comparison *************
        ****************************************************** -->
        <div class="table-responsive">
            <table class="table table-sm table-bordered table-striped w-100">
                <thead>
                    <tr>
                        <th style="width: 40%;" scope="col" translate>icashComparison.article</th>
                        <th style="width: 10%;" scope="col" translate>icashComparison.quantity</th>
                        <th style="width: 17%;" scope="col" translate>icashComparison.receiptTotal</th>
                        <th style="width: 17%;" scope="col" translate>icashComparison.inspectionTotal</th>
                        <th style="width: 16%;" scope="col" translate>icashComparison.statusLabel</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let line of lines">
                        <td>{{line.name}}</td>
                        <td class="text-right text-nowrap">{{line.receiptQuantity != null ? (line.receiptQuantity | number:'1.0-2') : '—'}}</td>
                        <td class="text-right text-nowrap">{{line.receiptTotal != null ? (line.receiptTotal | number:'1.2-2') : '—'}}</td>
                        <td class="text-right text-nowrap">{{line.inspectionTotal != null ? (line.inspectionTotal | number:'1.2-2') : '—'}}</td>
                        <td>
                            <span [ngClass]="lineStatusClass(line.lineStatus)" translate>{{lineStatusKey(line.lineStatus)}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="lines.length === 0" class="text-muted" translate>icashComparison.noLines</div>
    </div>

    <ng-container *ngIf="dataLoaded; else dataLoadingTemplate"></ng-container>
</mat-dialog-content>

<ng-template #dataLoadingTemplate>
    <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <i class="fa fa-refresh" (click)="reload()"></i>
        </div>
    </div>
    <ng-template #dataSpinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>
